import Foryou from "../images/covid19.jpeg";
import RIPLEGEND from "../images/covid.jpeg";


var foryouData = {
  headlines: {
    img: {Foryou},
    subTitle: "Business Insider India 🇮🇳",
    Title: " COVID-19 cases are on the rise in India — Maharashtra and Kerala reporting the highest surge in cases"

  },
  tweets: [{
    subhead: "COVID-19 · LIVE",
    title: "COVID-19 in India",
    img: {RIPLEGEND}
  },
  {
    subhead: "India national news · LIVE",
    title: "देश में COVID-19 के नए केसों में बढ़ोतरी"
  },
  {
    subhead: "NewsBytes · June 1, 2022",
    title: "No concerning trends caused by new Omicron subvariants: Experts",
    img: {RIPLEGEND}
  },
  {
    subhead: "Bloomberg Quicktake · June 1, 2022",
    title: "Shanghai residents experience freedom after 2 months of lockdown"
  }]
};
export default foryouData;
